import { render } from "./Fulfill.vue?vue&type=template&id=5edad841"
import script from "./Fulfill.vue?vue&type=script&lang=js"
export * from "./Fulfill.vue?vue&type=script&lang=js"

import "./Fulfill.vue?vue&type=style&index=0&id=5edad841&lang=scss"

import exportComponent from "/builds/root/lvgou_pub_mob/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__